/**
 * Free shipping progress bar — message + fill (Guttelus).
 * Cart drawer and PDP always use the same cart.total_price when the cart has items.
 */
(function () {
  var PLACEHOLDER = /\{\{\s*remaining_amount\s*\}\}/g;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number == null) {
      return '0';
    }

    var numString = (number / 100).toFixed(precision);
    var parts = numString.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  function formatFromTemplate(cents, format) {
    var placeholderMatch = format.match(/\{\{\s*(\w+)\s*\}\}/);

    if (!placeholderMatch) {
      return String(Math.round(Math.max(0, cents) / 100));
    }

    var placeholder = placeholderMatch[1];
    var value = '';

    switch (placeholder) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, ',', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 0, "'", '.');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 0);
        break;
    }

    return format.replace(placeholderMatch[0], value);
  }

  function shopMoneyFormat() {
    return (
      (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) ||
      '{{amount_no_decimals}},-'
    );
  }

  /** Remaining amount — no decimals, matches Liquid money_without_trailing_zeros. */
  function formatRemaining(cents) {
    var format = shopMoneyFormat()
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, '{{amount_no_decimals_with_space_separator}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, '{{amount_no_decimals_with_comma_separator}}')
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, '{{amount_no_decimals_with_apostrophe_separator}}')
      .replace(/\{\{\s*amount\s*\}\}/g, '{{amount_no_decimals}}');

    return formatFromTemplate(cents, format);
  }

  function cartProgressTotal(cart) {
    return cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
  }

  function cartJsUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;

    if (root) {
      return root + 'cart.js';
    }

    return '/cart.js';
  }

  var GuttelusShippingProgress = class extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.getAttribute('data-threshold-cents'), 10) || 0;
      this.context = this.getAttribute('data-context') || 'cart';
      this.messageEl = this.querySelector('.free-shipping-bar__message');
      this.fillEl = this.querySelector('.free-shipping-bar__fill');
      this.trackEl = this.querySelector('.free-shipping-bar__track');
      this._currentVariantPrice = parseInt(this.getAttribute('data-total-cents'), 10) || 0;

      this._onCartChange = this.handleCartChange.bind(this);
      this._onCartDrawerRefreshed = this.handleCartDrawerRefreshed.bind(this);

      document.addEventListener('cart:change', this._onCartChange);
      document.addEventListener('cart-drawer:refreshed', this._onCartDrawerRefreshed);

      if (this.context === 'product') {
        var formId = this.getAttribute('data-product-form-id');
        this._variantForm =
          (formId && document.getElementById(formId)) ||
          document.querySelector('.shopify-section--main-product form[is="product-form"], .shopify-section--featured-product form[is="product-form"]');

        if (this._variantForm) {
          this._onVariantChange = this.handleVariantChange.bind(this);
          this._variantForm.addEventListener('variant:change', this._onVariantChange);
        }

        this.refreshFromCart();
      } else {
        this.render(parseInt(this.getAttribute('data-total-cents'), 10) || 0);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('cart:change', this._onCartChange);
      document.removeEventListener('cart-drawer:refreshed', this._onCartDrawerRefreshed);

      if (this._onVariantChange && this._variantForm) {
        this._variantForm.removeEventListener('variant:change', this._onVariantChange);
      }
    }

    handleCartChange(event) {
      if (!event.detail || !event.detail.cart) {
        return;
      }

      this.applyCart(event.detail.cart);
    }

    handleCartDrawerRefreshed() {
      if (this.context === 'product') {
        this.refreshFromCart();
      }
    }

    refreshFromCart() {
      var self = this;

      fetch(cartJsUrl())
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          self.applyCart(cart);
        })
        .catch(function () {
          self.render(self.resolveTotalCents(null));
        });
    }

    handleVariantChange(event) {
      var variant = event.detail && event.detail.variant;

      if (!variant) {
        return;
      }

      this._currentVariantPrice = variant.price;

      if (this.getAttribute('data-use-cart-total') !== 'true') {
        this.render(variant.price);
      }
    }

    resolveTotalCents(cart) {
      if (this.context === 'product') {
        if (cart && cart.item_count > 0) {
          return cartProgressTotal(cart);
        }

        return this._currentVariantPrice;
      }

      if (cart) {
        return cartProgressTotal(cart);
      }

      return parseInt(this.getAttribute('data-total-cents'), 10) || 0;
    }

    applyCart(cart) {
      var useCartTotal = cart.item_count > 0;

      if (this.context === 'product') {
        if (useCartTotal) {
          this.setAttribute('data-use-cart-total', 'true');
        } else {
          this.removeAttribute('data-use-cart-total');
        }
      } else {
        this.hidden = cart.item_count === 0;
      }

      var totalCents = this.resolveTotalCents(cart);
      this.setAttribute('data-total-cents', totalCents);
      this.render(totalCents);
    }

    syncFill(totalCents) {
      if (!this.fillEl || this.threshold <= 0) {
        return;
      }

      totalCents = Math.max(0, totalCents);
      var percent = Math.min(100, (totalCents / this.threshold) * 100);

      this.fillEl.style.width = percent + '%';

      if (this.trackEl) {
        this.trackEl.setAttribute('aria-valuenow', String(Math.round(percent)));
      }
    }

    render(totalCents) {
      if (!this.messageEl || this.threshold <= 0) {
        return;
      }

      totalCents = Math.max(0, totalCents);

      var reached = totalCents >= this.threshold;
      var remaining = Math.max(0, this.threshold - totalCents);

      this.syncFill(totalCents);

      if (reached) {
        this.messageEl.innerHTML = this.getAttribute('data-reached-message') || '';
      } else {
        var template = this.getAttribute('data-unreached-message') || '';
        var amountHtml = '<strong>' + formatRemaining(remaining) + '</strong>';
        this.messageEl.innerHTML = template.replace(PLACEHOLDER, amountHtml);
      }
    }
  };

  if (!window.customElements.get('guttelus-shipping-progress')) {
    window.customElements.define('guttelus-shipping-progress', GuttelusShippingProgress);
  }
})();
